import { getEntityColor } from '@/components/entity-colors';

import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { moduleDefinitionsQueryOptions } from '@/queries/moduleDefinitionsQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { sidebarsQueryOptions } from '@/queries/sidebarsQueryOptions';
import { EntityTabItemLinkCount } from '@/components/entity-view/EntityTabItemLink';

export const Route = createFileRoute(
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs',
)({
    component: RouteComponent,
    loader: async ({ context: { queryClient }, params }) => {

        const { entity_type_id, entity_id } = params;

        await queryClient.ensureQueryData(moduleDefinitionsQueryOptions);

        await queryClient.ensureQueryData(getEntityQueryOptions(entity_type_id, entity_id));
        await queryClient.ensureQueryData(sidebarsQueryOptions(entity_type_id));

    }
})

function RouteComponent() {

    const { module_id, entity_type_id, entity_id } = Route.useParams();

    const moduleDefinitions = useQuery(moduleDefinitionsQueryOptions);
    const moduleDefinition = moduleDefinitions.data?.find(m => m.id === module_id);
    const { data: result } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));


    const color = getEntityColor(entity_type_id);
    const hideFirstColumnOnEntityTypes = ['reports', 'document-templates'];
    const hideFirstColumn = hideFirstColumnOnEntityTypes.includes(entity_type_id as string);

    return <>
        <div className={`bg-gray-50 border rounded-b-xl shadow-xs mt-0 h-full ${hideFirstColumn ? 'w-full' : 'w-[calc(100%-300px)]'}`}>
            <div className={`flex flex-col flex-1 h-full   bg-linear-to-b to-white`}
                style={{
                    backgroundColor: color?.backgroundColor
                }}
            >

                <div className="flex flex-row flex-wrap  -mb-px pl-2  pt-2 gap-1 0 rounded-t-2xl border-b border-gray-300">

                    {result?.view?.primaryTabs?.filter(t => !t.isSidePanel).map((tab, index) => {

                        if (tab.collection === 'details') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/details'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }
                        if (tab.collection === 'overview') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/overview'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }
                        if (tab.collection === 'design') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/design'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }

                        if (tab.collection === 'parameters') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/parameters'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }
                        if (tab.collection === 'attendance') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/attendance'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }
                        if (tab.collection === 'budget') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/budget'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }

                        if (tab.collection === 'relationships') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/relationships'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }

                        if (tab.collection === 'data-sources') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/data-sources'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }

                        if (tab.collection === 'view-report') {
                            return <Link
                                key={'tab-' + index}
                                replace={true}
                                to={'/$module_id/$entity_type_id/$entity_id/view-report'}
                                params={{
                                    module_id: moduleDefinition?.id as string,
                                    entity_type_id: entity_type_id,
                                    entity_id: entity_id,
                                }}
                                className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                                activeProps={{
                                    className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                                }}
                            >
                                {tab.name}
                            </Link>
                        }



                        return <Link
                            key={'tab-' + index}
                            replace={true}
                            to={'/$module_id/$entity_type_id/$entity_id/$subCollection'}
                            params={{
                                module_id: moduleDefinition?.id as string,
                                entity_type_id: entity_type_id,
                                entity_id: entity_id,
                                subCollection: tab.collection as string
                            }}
                            className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                            activeProps={{
                                className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                            }}
                        >
                            {tab.name}
                            {tab.showCount && <EntityTabItemLinkCount count={tab.count} />}

                        </Link>
                    })}
                    <Link
                        to={'/$module_id/$entity_type_id/$entity_id/details'}
                        replace={true}
                        params={{
                            module_id: moduleDefinition?.id as string,
                            entity_type_id: entity_type_id,
                            entity_id: entity_id
                        }}
                        className=" text-nowrap flex flex-row gap-2 text-sm bg-gray-200  border-gray-300 border p-2 rounded-md  pl-4 pr-4 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-b-none"
                        activeProps={{
                            className: 'bg-white text-nowrap flex flex-row gap-2 text-sm  border-gray-400 border p-2 rounded-md font-medium pl-4 pr-4 text-blue-500 hover:bg-gray-100 hover:text-gray-900 border-b-0 rounded-b-none'
                        }}
                    >Details</Link>
                    <div className="flex-1 border-gray-300 border-b"></div>
                </div>
                <div className="flex flex-1 bg-white h-full  rounded-t-xl " >
                    <Outlet />
                </div>
            </div>
        </div>
    </>
}
